// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profiling-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.profiling-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 600px;
  width: 100%;
  text-align: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.profiling-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #0877BC, #065a8f);
}

.profiling-header {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.profiling-logo {
  width: 180px;
  height: auto;
  margin-bottom: 25px;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  transition: transform 0.3s ease, filter 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 100%;
  box-sizing: border-box;
}

.profiling-logo img {
  width: 100%;
  height: auto;
  max-width: 100%;
  object-fit: contain;
}

.profiling-logo:hover {
  transform: scale(1.05);
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.2));
}

.profiling-header h1 {
  color: #2d3748;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 10px;
  background: linear-gradient(135deg, #0877BC, #065a8f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.profiling-header p {
  color: #718096;
  font-size: 1.1rem;
  margin: 0;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  margin-bottom: 30px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #0877BC, #065a8f);
  border-radius: 4px;
  transition: width 0.5s ease;
}

.question-container {
  margin-bottom: 30px;
  text-align: left;
}

.question-text {
  color: #2d3748;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 25px;
  line-height: 1.4;
}

.question-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Step Section Styling */
.step-section {
  margin-bottom: 30px;
  text-align: left;
}

.step-title {
  color: #2d3748;
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 1.4;
}

.step-description {
  color: #718096;
  font-size: 1.1rem;
  margin-bottom: 20px;
  line-height: 1.5;
}

.info-message {
  background: linear-gradient(135deg, #e6f3ff 0%, #d1ecf1 100%);
  border: 2px solid #0877BC;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 25px;
  text-align: left;
  box-shadow: 0 4px 12px rgba(8, 119, 188, 0.1);
}

.info-message p {
  margin: 0;
  color: #2d3748;
  font-size: 0.95rem;
  line-height: 1.4;
  font-weight: 500;
}

.info-message strong {
  color: #0877BC;
}

.options-grid {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 30px;
  width: 100%;
}

.option-button {
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px;
  font-size: 1.1rem;
  font-weight: 500;
  color: #4a5568;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
  position: relative;
  overflow: visible;
  min-height: 70px;
  display: flex;
  align-items: center;
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
  width: 100%;
  box-sizing: border-box;
}

.option-button:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.option-button.selected {
  background: linear-gradient(135deg, #0877BC, #065a8f);
  border-color: #0877BC;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(8, 119, 188, 0.3);
}

.option-button.selected::before {
  content: '✓';
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
  font-size: 1.2rem;
}

.option-button.disabled,
.option-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
  background: #e2e8f0;
  color: #a0aec0;
  border-color: #cbd5e0;
}

.option-button.disabled:hover,
.option-button:disabled:hover {
  transform: none;
  box-shadow: none;
}

.checkbox-option {
  display: flex;
  align-items: center;
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 8px;
}

.checkbox-option:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.checkbox-option input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin-right: 15px;
  accent-color: #0877BC;
  cursor: pointer;
}

.checkbox-label {
  font-size: 1rem;
  font-weight: 500;
  color: #4a5568;
  cursor: pointer;
  flex: 1 1;
}

.text-input-container {
  margin-top: 15px;
}

.text-input {
  width: 100%;
  min-height: 120px;
  padding: 16px 20px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  transition: all 0.3s ease;
  background: #f7fafc;
  color: #4a5568;
}

.text-input:focus {
  outline: none;
  border-color: #0877BC;
  background: white;
  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);
}

.text-input::placeholder {
  color: #a0aec0;
}

/* Navigation Section */
.navigation-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-top: 30px;
}

.back-button,
.next-button {
  background: linear-gradient(135deg, #0877BC, #065a8f);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px 32px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
}

.back-button:hover,
.next-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(8, 119, 188, 0.3);
}

.back-button:disabled,
.next-button:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.button-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.error-message {
  background: #fed7d7;
  color: #c53030;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  border: 1px solid #feb2b2;
  font-weight: 500;
}

.success-message {
  background: #c6f6d5;
  color: #22543d;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  border: 1px solid #9ae6b4;
  font-weight: 500;
}

.keyboard-hint {
  text-align: center;
  margin-top: 15px;
  color: #6c757d;
  font-size: 0.9rem;
  opacity: 0.8;
}

.keyboard-hint kbd {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 0.8rem;
  font-family: monospace;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .profiling-container {
    padding: 10px 10px max(4.5rem, calc(1rem + env(safe-area-inset-bottom, 0px)));
    box-sizing: border-box;
    min-height: 100dvh;
  }
  
  .profiling-card {
    padding: 30px 20px;
  }
  
  .profiling-header h1 {
    font-size: 2rem;
  }
  
  .step-title {
    font-size: 1.4rem;
  }
  
  .step-description {
    font-size: 1rem;
  }
  
  .option-button {
    padding: 18px 20px;
    font-size: 1rem;
    min-height: 65px;
  }
  
  .next-button {
    padding: 14px 30px;
    font-size: 1rem;
  }
  
  .profiling-logo {
    width: 150px;
    height: auto;
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .profiling-card {
    padding: 20px 15px;
  }
  
  .profiling-header h1 {
    font-size: 1.8rem;
  }
  
  .step-title {
    font-size: 1.3rem;
  }
  
  .step-description {
    font-size: 0.95rem;
  }
  
  .option-button {
    padding: 16px 18px;
    font-size: 0.95rem;
    min-height: 60px;
  }
  
  .profiling-logo {
    width: 130px;
    height: auto;
    padding: 14px;
  }
  
  .next-button {
    padding: 12px 24px;
    font-size: 0.95rem;
  }
  
  .keyboard-hint {
    font-size: 0.85rem;
  }
}

/* Input Fields */
.input-field {
  width: 100%;
  margin-bottom: 15px;
}

.date-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #4a5568;
  font-size: 0.95rem;
}

.input-field input {
  width: 100%;
  padding: 15px 20px;
  border: 2px solid #e1e5e9;
  border-radius: 12px;
  font-size: 1.1rem;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.input-field input:focus {
  outline: none;
  border-color: #0877BC;
  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);
  background: rgba(255, 255, 255, 0.95);
}

.input-field input::placeholder {
  color: #6c757d;
  opacity: 0.7;
}

/* Date Input */
.date-input {
  font-family: inherit;
  cursor: text;
}

.date-input::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.7;
  -webkit-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
}

.date-input::-webkit-calendar-picker-indicator:hover {
  opacity: 1;
}

/* Email Input */
.email-input {
  font-family: inherit;
}

/* Password Fields */
.password-fields {
  width: 100%;
}

.password-fields .input-field {
  margin-bottom: 20px;
}

.password-input {
  font-family: inherit;
}

/* Error Message */
.error-message {
  color: #dc3545;
  font-size: 0.9rem;
  margin-top: 5px;
  text-align: center;
  background: rgba(220, 53, 69, 0.1);
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid rgba(220, 53, 69, 0.2);
}

/* Warning Message for Email Confirmation */
.email-step .error-message {
  background: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.3);
  color: #856404;
  font-weight: 500;
  padding: 15px;
  margin-top: 15px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.4;
}

/* Email Confirmation Styles */
.email-step {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.email-validation-section {
  margin-top: 1.5rem;
  text-align: center;
}

.validate-email-button {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

.validate-email-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}

.validate-email-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

.validation-hint {
  color: #6c757d;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  font-style: italic;
}

.email-exists-error {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  border: 2px solid #ffc107;
  border-radius: 10px;
  padding: 1.5rem;
  margin-top: 1rem;
  text-align: left;
}

.email-exists-error p {
  margin: 0.5rem 0;
  color: #856404;
  font-weight: 500;
}

.email-exists-error ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
  color: #856404;
}

.email-exists-error li {
  margin: 0.5rem 0;
}

.email-exists-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  justify-content: center;
}

.login-button, .try-different-email-button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.login-button {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}

.try-different-email-button {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

.try-different-email-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);
}

.confirmation-message {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  border: 1px solid #c3e6cb;
  border-radius: 12px;
  padding: 25px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.1);
}

.success-icon {
  font-size: 48px;
  margin-bottom: 15px;
  animation: bounce 0.6s ease-in-out;
}

.confirmation-message p {
  margin: 10px 0;
  color: #155724;
  font-size: 16px;
  line-height: 1.5;
}

.confirmation-message p:first-of-type {
  font-weight: 600;
  font-size: 18px;
}

.continue-button {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 15px auto 0 auto;
  display: block;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

.continue-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}

.continue-button:active {
  transform: translateY(0);
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

/* Email input disabled state */
.email-input:disabled {
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Country Dropdown Styles */
.country-dropdown-container {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.country-search-container {
  position: relative;
  margin-bottom: 15px;
}

.country-search-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  background: white;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.country-search-input:focus {
  outline: none;
  border-color: #0877BC;
  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);
}

.country-dropdown {
  max-height: 300px;
  overflow-y: auto;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.country-option {
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: white;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.country-option:last-child {
  border-bottom: none;
}

.country-option:hover {
  background-color: #f8f9fa;
  transform: translateX(2px);
}

.country-option.selected {
  background-color: #e3f2fd;
  color: #0877BC;
  font-weight: 600;
}

.country-option.selected:hover {
  background-color: #bbdefb;
}

.country-option.focused {
  background-color: #e8f4fd;
  border-left: 3px solid #0877BC;
  transform: translateX(2px);
}

.country-flag {
  font-size: 20px;
  width: 24px;
  text-align: center;
  flex-shrink: 0;
}

.country-name {
  flex: 1 1;
  font-weight: 500;
}

.country-code {
  color: #666;
  font-size: 12px;
  font-weight: 600;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
  flex-shrink: 0;
}

.country-option.selected .country-code {
  background: #0877BC;
  color: white;
}

/* Scrollbar styling for country dropdown */
.country-dropdown::-webkit-scrollbar {
  width: 6px;
}

.country-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.country-dropdown::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.country-dropdown::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Club Dropdown Styles */
.club-dropdown-container {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.club-search-container {
  position: relative;
  margin-bottom: 15px;
}

.club-search-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  background: white;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.club-search-input:focus {
  outline: none;
  border-color: #0877BC;
  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);
}

.club-dropdown {
  max-height: 300px;
  overflow-y: auto;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.club-option {
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: white;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
}

.club-option:last-child {
  border-bottom: none;
}

.club-option:hover {
  background: #f8f9fa;
}

.club-option.focused {
  background: #e3f2fd;
  border-left: 4px solid #0877BC;
}

.club-option.selected {
  background: #0877BC;
  color: white;
}

.club-name {
  font-weight: 600;
  font-size: 16px;
  color: inherit;
}

.club-city {
  font-size: 14px;
  color: #666;
  font-style: italic;
}

.club-option.selected .club-city {
  color: rgba(255, 255, 255, 0.8);
}

/* Scrollbar styling for club dropdown */
.club-dropdown::-webkit-scrollbar {
  width: 6px;
}

.club-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.club-dropdown::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.club-dropdown::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Icon styles */
.step-icon {
  font-size: 24px !important;
  margin-right: 12px;
  color: #0877BC;
  vertical-align: middle;
}

.option-icon {
  font-size: 20px !important;
  margin-right: 8px;
  color: #0877BC;
  vertical-align: middle;
}

.option-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.step-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

/* Icon hover effects */
.option-button:hover .option-icon {
  color: #065a8f;
  transform: scale(1.1);
  transition: all 0.2s ease;
}

.option-button.selected .option-icon {
  color: white;
}

/* Stars container for experience levels */
.stars-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.stars-container .option-icon {
  margin-right: 0;
  font-size: 16px !important;
}

/* Responsive icon sizing */
@media (max-width: 768px) {
  .step-icon {
    font-size: 20px !important;
    margin-right: 8px;
  }
  
  .option-icon {
    font-size: 18px !important;
    margin-right: 6px;
  }
  
  .stars-container .option-icon {
    font-size: 14px !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/PlayerProfiling.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,iDAAiD;EACjD,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sBAAsB;AACtB;EACE;IACE,6EAA6E;IAC7E,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qCAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,2CAA2C;AAC3C;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,wCAAwC;AACxC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".profiling-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.profiling-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  max-width: 600px;\n  width: 100%;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.profiling-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #0877BC, #065a8f);\n}\n\n.profiling-header {\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.profiling-logo {\n  width: 180px;\n  height: auto;\n  margin-bottom: 25px;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));\n  transition: transform 0.3s ease, filter 0.3s ease;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 20px;\n  border-radius: 20px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.profiling-logo img {\n  width: 100%;\n  height: auto;\n  max-width: 100%;\n  object-fit: contain;\n}\n\n.profiling-logo:hover {\n  transform: scale(1.05);\n  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.2));\n}\n\n.profiling-header h1 {\n  color: #2d3748;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 10px;\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.profiling-header p {\n  color: #718096;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e2e8f0;\n  border-radius: 4px;\n  margin-bottom: 30px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #0877BC, #065a8f);\n  border-radius: 4px;\n  transition: width 0.5s ease;\n}\n\n.question-container {\n  margin-bottom: 30px;\n  text-align: left;\n}\n\n.question-text {\n  color: #2d3748;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 25px;\n  line-height: 1.4;\n}\n\n.question-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Step Section Styling */\n.step-section {\n  margin-bottom: 30px;\n  text-align: left;\n}\n\n.step-title {\n  color: #2d3748;\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n  line-height: 1.4;\n}\n\n.step-description {\n  color: #718096;\n  font-size: 1.1rem;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.info-message {\n  background: linear-gradient(135deg, #e6f3ff 0%, #d1ecf1 100%);\n  border: 2px solid #0877BC;\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin-bottom: 25px;\n  text-align: left;\n  box-shadow: 0 4px 12px rgba(8, 119, 188, 0.1);\n}\n\n.info-message p {\n  margin: 0;\n  color: #2d3748;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  font-weight: 500;\n}\n\n.info-message strong {\n  color: #0877BC;\n}\n\n.options-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-bottom: 30px;\n  width: 100%;\n}\n\n.option-button {\n  background: #f7fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px 24px;\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #4a5568;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: left;\n  position: relative;\n  overflow: visible;\n  min-height: 70px;\n  display: flex;\n  align-items: center;\n  word-wrap: break-word;\n  white-space: normal;\n  line-height: 1.4;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.option-button:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.option-button.selected {\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  border-color: #0877BC;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(8, 119, 188, 0.3);\n}\n\n.option-button.selected::before {\n  content: '✓';\n  position: absolute;\n  right: 24px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-weight: bold;\n  font-size: 1.2rem;\n}\n\n.option-button.disabled,\n.option-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n  background: #e2e8f0;\n  color: #a0aec0;\n  border-color: #cbd5e0;\n}\n\n.option-button.disabled:hover,\n.option-button:disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n.checkbox-option {\n  display: flex;\n  align-items: center;\n  background: #f7fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 16px 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 8px;\n}\n\n.checkbox-option:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.checkbox-option input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  margin-right: 15px;\n  accent-color: #0877BC;\n  cursor: pointer;\n}\n\n.checkbox-label {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #4a5568;\n  cursor: pointer;\n  flex: 1;\n}\n\n.text-input-container {\n  margin-top: 15px;\n}\n\n.text-input {\n  width: 100%;\n  min-height: 120px;\n  padding: 16px 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-family: inherit;\n  resize: vertical;\n  transition: all 0.3s ease;\n  background: #f7fafc;\n  color: #4a5568;\n}\n\n.text-input:focus {\n  outline: none;\n  border-color: #0877BC;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);\n}\n\n.text-input::placeholder {\n  color: #a0aec0;\n}\n\n/* Navigation Section */\n.navigation-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.back-button,\n.next-button {\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  padding: 16px 32px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 120px;\n}\n\n.back-button:hover,\n.next-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(8, 119, 188, 0.3);\n}\n\n.back-button:disabled,\n.next-button:disabled {\n  background: #cbd5e0;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.button-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.2rem;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top: 4px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n.error-message {\n  background: #fed7d7;\n  color: #c53030;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  border: 1px solid #feb2b2;\n  font-weight: 500;\n}\n\n.success-message {\n  background: #c6f6d5;\n  color: #22543d;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  border: 1px solid #9ae6b4;\n  font-weight: 500;\n}\n\n.keyboard-hint {\n  text-align: center;\n  margin-top: 15px;\n  color: #6c757d;\n  font-size: 0.9rem;\n  opacity: 0.8;\n}\n\n.keyboard-hint kbd {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 0.8rem;\n  font-family: monospace;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .profiling-container {\n    padding: 10px 10px max(4.5rem, calc(1rem + env(safe-area-inset-bottom, 0px)));\n    box-sizing: border-box;\n    min-height: 100dvh;\n  }\n  \n  .profiling-card {\n    padding: 30px 20px;\n  }\n  \n  .profiling-header h1 {\n    font-size: 2rem;\n  }\n  \n  .step-title {\n    font-size: 1.4rem;\n  }\n  \n  .step-description {\n    font-size: 1rem;\n  }\n  \n  .option-button {\n    padding: 18px 20px;\n    font-size: 1rem;\n    min-height: 65px;\n  }\n  \n  .next-button {\n    padding: 14px 30px;\n    font-size: 1rem;\n  }\n  \n  .profiling-logo {\n    width: 150px;\n    height: auto;\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .profiling-card {\n    padding: 20px 15px;\n  }\n  \n  .profiling-header h1 {\n    font-size: 1.8rem;\n  }\n  \n  .step-title {\n    font-size: 1.3rem;\n  }\n  \n  .step-description {\n    font-size: 0.95rem;\n  }\n  \n  .option-button {\n    padding: 16px 18px;\n    font-size: 0.95rem;\n    min-height: 60px;\n  }\n  \n  .profiling-logo {\n    width: 130px;\n    height: auto;\n    padding: 14px;\n  }\n  \n  .next-button {\n    padding: 12px 24px;\n    font-size: 0.95rem;\n  }\n  \n  .keyboard-hint {\n    font-size: 0.85rem;\n  }\n}\n\n/* Input Fields */\n.input-field {\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n.date-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #4a5568;\n  font-size: 0.95rem;\n}\n\n.input-field input {\n  width: 100%;\n  padding: 15px 20px;\n  border: 2px solid #e1e5e9;\n  border-radius: 12px;\n  font-size: 1.1rem;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.input-field input:focus {\n  outline: none;\n  border-color: #0877BC;\n  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);\n  background: rgba(255, 255, 255, 0.95);\n}\n\n.input-field input::placeholder {\n  color: #6c757d;\n  opacity: 0.7;\n}\n\n/* Date Input */\n.date-input {\n  font-family: inherit;\n  cursor: text;\n}\n\n.date-input::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.3s ease;\n}\n\n.date-input::-webkit-calendar-picker-indicator:hover {\n  opacity: 1;\n}\n\n/* Email Input */\n.email-input {\n  font-family: inherit;\n}\n\n/* Password Fields */\n.password-fields {\n  width: 100%;\n}\n\n.password-fields .input-field {\n  margin-bottom: 20px;\n}\n\n.password-input {\n  font-family: inherit;\n}\n\n/* Error Message */\n.error-message {\n  color: #dc3545;\n  font-size: 0.9rem;\n  margin-top: 5px;\n  text-align: center;\n  background: rgba(220, 53, 69, 0.1);\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1px solid rgba(220, 53, 69, 0.2);\n}\n\n/* Warning Message for Email Confirmation */\n.email-step .error-message {\n  background: rgba(255, 193, 7, 0.1);\n  border: 1px solid rgba(255, 193, 7, 0.3);\n  color: #856404;\n  font-weight: 500;\n  padding: 15px;\n  margin-top: 15px;\n  border-radius: 12px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Email Confirmation Styles */\n.email-step {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.email-validation-section {\n  margin-top: 1.5rem;\n  text-align: center;\n}\n\n.validate-email-button {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n}\n\n.validate-email-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);\n}\n\n.validate-email-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);\n}\n\n.validation-hint {\n  color: #6c757d;\n  font-size: 0.9rem;\n  margin-top: 0.5rem;\n  font-style: italic;\n}\n\n.email-exists-error {\n  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);\n  border: 2px solid #ffc107;\n  border-radius: 10px;\n  padding: 1.5rem;\n  margin-top: 1rem;\n  text-align: left;\n}\n\n.email-exists-error p {\n  margin: 0.5rem 0;\n  color: #856404;\n  font-weight: 500;\n}\n\n.email-exists-error ul {\n  margin: 1rem 0;\n  padding-left: 1.5rem;\n  color: #856404;\n}\n\n.email-exists-error li {\n  margin: 0.5rem 0;\n}\n\n.email-exists-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n  justify-content: center;\n}\n\n.login-button, .try-different-email-button {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n}\n\n.login-button {\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  color: white;\n  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);\n}\n\n.login-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);\n}\n\n.try-different-email-button {\n  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n  color: white;\n  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);\n}\n\n.try-different-email-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.4);\n}\n\n.confirmation-message {\n  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);\n  border: 1px solid #c3e6cb;\n  border-radius: 12px;\n  padding: 25px;\n  text-align: center;\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.1);\n}\n\n.success-icon {\n  font-size: 48px;\n  margin-bottom: 15px;\n  animation: bounce 0.6s ease-in-out;\n}\n\n.confirmation-message p {\n  margin: 10px 0;\n  color: #155724;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n.confirmation-message p:first-of-type {\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.continue-button {\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin: 15px auto 0 auto;\n  display: block;\n  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n}\n\n.continue-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);\n}\n\n.continue-button:active {\n  transform: translateY(0);\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-10px);\n  }\n  60% {\n    transform: translateY(-5px);\n  }\n}\n\n/* Email input disabled state */\n.email-input:disabled {\n  background-color: #f8f9fa;\n  color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* Country Dropdown Styles */\n.country-dropdown-container {\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.country-search-container {\n  position: relative;\n  margin-bottom: 15px;\n}\n\n.country-search-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 16px;\n  background: white;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.country-search-input:focus {\n  outline: none;\n  border-color: #0877BC;\n  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);\n}\n\n.country-dropdown {\n  max-height: 300px;\n  overflow-y: auto;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.country-option {\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: white;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 14px;\n}\n\n.country-option:last-child {\n  border-bottom: none;\n}\n\n.country-option:hover {\n  background-color: #f8f9fa;\n  transform: translateX(2px);\n}\n\n.country-option.selected {\n  background-color: #e3f2fd;\n  color: #0877BC;\n  font-weight: 600;\n}\n\n.country-option.selected:hover {\n  background-color: #bbdefb;\n}\n\n.country-option.focused {\n  background-color: #e8f4fd;\n  border-left: 3px solid #0877BC;\n  transform: translateX(2px);\n}\n\n.country-flag {\n  font-size: 20px;\n  width: 24px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.country-name {\n  flex: 1;\n  font-weight: 500;\n}\n\n.country-code {\n  color: #666;\n  font-size: 12px;\n  font-weight: 600;\n  background: #f5f5f5;\n  padding: 2px 6px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.country-option.selected .country-code {\n  background: #0877BC;\n  color: white;\n}\n\n/* Scrollbar styling for country dropdown */\n.country-dropdown::-webkit-scrollbar {\n  width: 6px;\n}\n\n.country-dropdown::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.country-dropdown::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.country-dropdown::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Club Dropdown Styles */\n.club-dropdown-container {\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.club-search-container {\n  position: relative;\n  margin-bottom: 15px;\n}\n\n.club-search-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 16px;\n  background: white;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.club-search-input:focus {\n  outline: none;\n  border-color: #0877BC;\n  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);\n}\n\n.club-dropdown {\n  max-height: 300px;\n  overflow-y: auto;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.club-option {\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: white;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.club-option:last-child {\n  border-bottom: none;\n}\n\n.club-option:hover {\n  background: #f8f9fa;\n}\n\n.club-option.focused {\n  background: #e3f2fd;\n  border-left: 4px solid #0877BC;\n}\n\n.club-option.selected {\n  background: #0877BC;\n  color: white;\n}\n\n.club-name {\n  font-weight: 600;\n  font-size: 16px;\n  color: inherit;\n}\n\n.club-city {\n  font-size: 14px;\n  color: #666;\n  font-style: italic;\n}\n\n.club-option.selected .club-city {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Scrollbar styling for club dropdown */\n.club-dropdown::-webkit-scrollbar {\n  width: 6px;\n}\n\n.club-dropdown::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.club-dropdown::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.club-dropdown::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Icon styles */\n.step-icon {\n  font-size: 24px !important;\n  margin-right: 12px;\n  color: #0877BC;\n  vertical-align: middle;\n}\n\n.option-icon {\n  font-size: 20px !important;\n  margin-right: 8px;\n  color: #0877BC;\n  vertical-align: middle;\n}\n\n.option-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.step-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n/* Icon hover effects */\n.option-button:hover .option-icon {\n  color: #065a8f;\n  transform: scale(1.1);\n  transition: all 0.2s ease;\n}\n\n.option-button.selected .option-icon {\n  color: white;\n}\n\n/* Stars container for experience levels */\n.stars-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n}\n\n.stars-container .option-icon {\n  margin-right: 0;\n  font-size: 16px !important;\n}\n\n/* Responsive icon sizing */\n@media (max-width: 768px) {\n  .step-icon {\n    font-size: 20px !important;\n    margin-right: 8px;\n  }\n  \n  .option-icon {\n    font-size: 18px !important;\n    margin-right: 6px;\n  }\n  \n  .stars-container .option-icon {\n    font-size: 14px !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
